import * as React from 'react';
import './NewInputDropSite.css';

import { DropTarget, DragSource, DropTargetSpec, DropTargetConnector, DropTargetMonitor } from 'react-dnd'
// import { linkHorizontal } from 'd3'
// import classNames from 'classnames'
// import * as _ from 'lodash'
import {makeBox, boxContains, setVars, parseConstraintTemplate as kfParse, Constraint, tree} from 'kiwifruit'

import * as actions from '../actions'

import classNames from 'classnames'
import * as _ from 'lodash'

import * as Model from '../types/document'
import { Cursor } from '../lib/Cursor';
import { nodeInfo, referredOrOwnNodeId, NodeInfo } from 'src/model/nodeInfo';
import { NodeDrag, NewDrag } from 'src/view/drags';
import { canDragFromStackIntoStack, Stack } from 'src/types/stack';

const {weak} = Constraint


interface NewInputDropSiteProps {
  x: number, y: number, width: number,
  blockC: Cursor<Model.Block>,
  callC: Cursor<Model.Call>,
  graphC: Cursor<Model.Graph>,
  stack: Stack,
  index: number
}


class NewInputDropSite extends React.Component<NewInputDropSiteProps & ReturnType<typeof dropCollect>> {
  render() {
    const { connectDropTarget, canDrop, isOver,
            // definition, call, document,
            x, y, width} = this.props

    return connectDropTarget(
      <div 
        className={classNames({
          "NewInputDropSite": true,
          "NewInputDropSite-can-drop": canDrop,
          "NewInputDropSite-is-over": isOver
        })}
        style={{position: 'absolute', left: x, top: y, width}}
      />
    )
  }
}

const dropSpec: DropTargetSpec<NewInputDropSiteProps> = {
  drop(props, monitor) { actions.act(() => {
    switch (monitor.getItemType()) {
    case 'node':
      const nodeDrag = monitor.getItem() as NodeDrag
      switch (nodeDrag.type) {
        case 'move-subtree':
          actions.moveSubtree(nodeDrag.blockC, nodeDrag.nodeId, props.graphC)
          actions.addInput(props.callC, nodeDrag.nodeId, props.index)
          break
        case 'copy-reference':
          const newRefNodeId = actions.addReferenceNodeToGraph(referredOrOwnNodeId(nodeDrag.blockC, nodeDrag.nodeId), props.graphC, props.blockC)
          actions.addInput(props.callC, newRefNodeId, props.index)
          break
        default:
          throw new Error(`tried to drop unknown cell-type ${nodeDrag.type} on StepSpacer`)
      }
      break
    case 'new':
      const newDrag = monitor.getItem() as NewDrag
      switch (newDrag.type) {
        case 'node':
          const newEmptyNodeId = actions.addEmptyCodeCall(props.graphC)
          actions.addInput(props.callC, newEmptyNodeId, props.index)
          break
        default:
          throw new Error(`some weird kinda newDrag: ${newDrag.type}`)
      }
      break
    }
  })},

  canDrop(props, monitor) {
    switch (monitor.getItemType()) {
      case 'node':
        const nodeDrag = monitor.getItem() as NodeDrag
        return canDragFromStackIntoStack(nodeDrag.stack, props.stack)
      case 'new':
        const newDrag = monitor.getItem() as NewDrag
        return newDrag.type === 'node'
    }
    return false
  }
}

function dropCollect(connect: DropTargetConnector, monitor: DropTargetMonitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  };
}

export default DropTarget(["node", "new"], dropSpec, dropCollect, {arePropsEqual: () => false})(NewInputDropSite)



// WEBPACK FOOTER //
// ./src/view/NewInputDropSite.tsx